<section class="content">
  <div class="container">
    <h3 class="text strat pt-3">Tyre Model Name</h3>
    <form (ngSubmit)="saveVehicleModel()" [formGroup]="addTyreModelForm">
      <div class="row pt-3">
        <div class="col-md-4">
          <label for="name">Name</label>
          <input
            formControlName="name"
            id="name"
            type="text"
            class="form-control"
            required
            placeholder="Enter vehicle model name*"
            >
            @if (addTyreModelForm.get('name')?.invalid && addTyreModelForm.get('name')?.touched) {
              <div
                >
                <small class="text-danger">Vehicle model name is required</small>
              </div>
            }
          </div>
          <div class="col-md-4">
            <label for="tyreMake">Tyre Make</label>
            <select
              class="form-select"
              formControlName="tyreMake"
              id="tyreMake"
              required
              >
              <option value="">Select Tyre Make</option>
              @for (option of makeList; track option) {
                <option [value]="option.name">{{option.name}}</option>
              }
            </select>
            @if (
              addTyreModelForm.get('tyreMake')?.invalid &&
              addTyreModelForm.get('tyreMake')?.touched ) {
              <div>
                <small class="text-danger">Please select tyre make</small>
              </div>
            }
          </div>
          <div class="col-md-3 py-4">
            <button
              type="submit"
              class="btn app-btn-primary"
              [disabled]="addTyreModelForm.invalid"
            >Submit</button>
            <div>{{responseMsg}}</div>
          </div>

        </div>
      </form>
    </div>
  </section>
